<template>
  <div>
    Display XML Attributes Here...
  </div>
</template>

<script>
export default {
  name: 'XMLAttributes',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
